import * as types from '../types';
import { IPriceChartsApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class PriceChartsHttpApi extends HttpApi implements IPriceChartsApi {
  async listPriceCharts(): Promise<types.PriceChart[]> {
    // Backend returns every chart for the tenant in one unpaginated array.
    const response = await this.http.get<types.APIResponse<types.PriceChart[]>>('/price-charts');
    return response.data.data;
  }

  async getPriceChart(id: string): Promise<types.PriceChart> {
    const response = await this.http.get<types.APIResponse<types.PriceChart>>(`/price-charts/${id}`);
    return response.data.data;
  }

  async createPriceChart(data: types.CreatePriceChartRequest): Promise<types.PriceChart> {
    const response = await this.http.post<types.APIResponse<types.PriceChart>>('/price-charts', data);
    return response.data.data;
  }

  async updatePriceChart(id: string, data: types.UpdatePriceChartRequest): Promise<types.PriceChart> {
    const response = await this.http.patch<types.APIResponse<types.PriceChart>>(`/price-charts/${id}`, data);
    return response.data.data;
  }

  async replacePriceChartTiers(id: string, tiers: types.PriceChartTierInput[]): Promise<types.PriceChart> {
    const response = await this.http.put<types.APIResponse<types.PriceChart>>(`/price-charts/${id}/tiers`, { tiers });
    return response.data.data;
  }

  async deletePriceChart(id: string): Promise<void> {
    await this.http.delete(`/price-charts/${id}`);
  }

  async listSizeUnits(): Promise<types.SizeUnitOption[]> {
    const response = await this.http.get<types.APIResponse<types.SizeUnitOption[]>>('/price-charts/units');
    return response.data.data;
  }

  async quotePrice(data: types.PriceQuoteRequest): Promise<types.PriceQuote> {
    const response = await this.http.post<types.APIResponse<types.PriceQuote>>('/pricing/quote', data);
    return response.data.data;
  }
}
